import { motion } from 'framer-motion';

import { Form } from 'js/components';

export default function Page() {
  return (
    <main>
      <motion.div
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1 },
        }}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.5 }}
      >
        <Form />
      </motion.div>
    </main>
  );
}
